/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import ViewDocumentAttachments from "./DocumentAttachment";
import Breadcrumbs from "components/Breadcrumbs";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { getDocumentDetailApi } from "api/services/documents";
import { useDocument } from "./../context/documentContext";
import AllDocumentAddPopup from "../../../../components/modelpopup/AllDocumentAddPopup";
import Image from "components/Image";
import { formatDateHandler2 } from "utils/common";


const DocumentDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const {
    loading,
    documentData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDocumentDetailPage,
    selectedPage,
    documentModal,
    setSelectedDocument,
    setDocumentModal,
    selectedDocument,
    setLoading,
    documentType,
    documentTypeLoading,
    storeType
  } = useDocument();


  const [documentDetail, setDocumentData] = useState({});
  const [attachmentData, setAttachmentData] = useState([]) 
  useEffect(() => {


    console.log(location, navigate, params, "LLL");
    if (params?.id) {
      getDocumentList()
    }
  }, [params?.id, documentType]);
  const getDocumentList = ()=>{
    getDocumentDetailApi(params?.id).then((response) => {
      console.log(response, "REEEEEEE");
      setDocumentData(response.data);

      const attachmentData =  [
        { id: 1, title: "Document Name", text:response.data?.name},
        { id: 2, title: "Document Type", text: documentType.find(item=>item.id ==response.data?.document_type?.id)?.name },
        { id: 3, title: "Issue Date", text:formatDateHandler2(response.data?.issue_date)},
        { id: 4, title: "Expiry Date", text:formatDateHandler2(response.data?.expiry_date)},
        { id: 5, title: "Expires In", text: response.data?.expiry_in_days ? response.data?.expiry_in_days > 0 ? `${response.data?.expiry_in_days} day(s) ` : "EXPIRED" : "N/A " },
     
       
    
      ]
      setAttachmentData(attachmentData) 

    });
  }
  const getIndex = useMemo(()=>{

    console.log(documentData, documentDetail, "KKKKKKKKKKKKKKKKKKKKKK")
    const index = documentData.findIndex(doc => doc.id === documentDetail.id);
    return index
    
  },[documentData, documentDetail])

  const handleClickGoBack = () => {
    navigate(-1);
  };

  const handleClickNext = () => {
    const nextIndex = getIndex + 1;
    console.log(nextIndex,getIndex, "LLLL")
    if (nextIndex < pageSettings.total) {
      let nextDocument = documentData[nextIndex];
      handleDocumentDetailPage(nextDocument.id, nextIndex);
    }
  };

  const handleClickPrevious = () => {
    const prevIndex = getIndex - 1;
    if (prevIndex >= 0) {
      let nextDocument = documentData[prevIndex];
      handleDocumentDetailPage(nextDocument.id, prevIndex);
    }
  };

  const createDocumentHandler = () => {

  }
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Document Detail"
            title="Documents"
            subtitle="Employee Documents"
            modal="#add_indicator"
            name="Add New"
            showModal={false}
            linkName="/documents"
          />













          <div className="contact-head">
            <div className="row align-items-center">
              <div className="col-sm-6">
                <ul className="contact-breadcrumb">
                  <li>
                    <Link to="#" 
                    onClick={()=> navigate(-1)}
                    >
                      <i className="las la-arrow-left" /> Documents
                    </Link>
                  </li>
                  <li>
                    {documentDetail?.company_user?.first_name} {documentDetail?.company_user?.last_name}
                  </li>
                </ul>
              </div>
              <div className="col-sm-6 text-sm-end">
                <div className="contact-pagination">
                  <p>
                  {getIndex+1} of {pageSettings.total}
                  </p>
                  <ul>
                    <li>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          handleClickPrevious();
                        }}
                        // to="/contact-details"
                      >
                        <i className="las la-arrow-left" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          handleClickNext();
                        }}
                        // to="/contact-details"
                      >
                        <i className="las la-arrow-right" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">
                    <div className="profile-img-wrap">
                      <div className="profile-img">
                        <Link to="#">
                          <Image src={documentDetail?.company_user?.profile_image} alt="User Image" placeholder={"user"} />
                        </Link>
                      </div>
                    </div>
                    <div className="profile-basic">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="profile-info">
                            <h3 className="user-name m-t-0 mb-0">
                              {documentDetail?.company_user?.first_name} {documentDetail?.company_user?.last_name}
                            </h3>
                            <span className="small doj text-muted">{documentDetail?.company_user?.emp_no}</span>
                            <h6 className="text-muted">
                              {documentDetail?.company_user?.position_name}
                            </h6>                        
                            <div className="small doj text-muted">
                              Email :{" "}
                              {documentDetail?.company_user?.email}
                            </div>                           
                          </div>
                        </div>                       
                      </div>

                      <div className="mt-3 row">                     
                        <div className="col-md-12">
                        <ul className="personal-info">
                        {attachmentData.map((item, index) => (
                          <ListItem
                            id={item.id}
                            key={index}
                            title={item.title}
                            text={item.text}
                          />
                        ))}
                  </ul>

                

                <ViewDocumentAttachments documentDetail={documentDetail} />
           
                        </div>
                      </div>
                    </div>
                    <div className="pro-edit">
                      <Link
                      onClick={()=>{
                        setSelectedDocument(documentDetail)
                        setDocumentModal(true)
                      }}
                        // data-bs-target="#profile_info"
                        // data-bs-toggle="modal"
                        className="edit-icon"
                        // to="#"
                      >
                        <i className="fa-solid fa-pencil"></i>
                      </Link>
                    </div>

                    <AllDocumentAddPopup getDocumentList={getDocumentList} documentType={documentType} documentTypeLoading={documentTypeLoading} setSelectedDocument={setSelectedDocument} setLoading={setLoading} selectedDocument={selectedDocument} loading={loading} createDocumentHandler={createDocumentHandler} documentModal={documentModal} setDocumentModal={setDocumentModal} storeType={storeType} />

                  </div>
                </div>
              </div>
            </div>
          </div>

        
          {/* Document Details */}
          {/* <DocumentDetailTab documentDetail={documentDetail} /> */}
        </div>
      </div>
    </>
  );
};

export const ListItem = ({ title, text }) => (
  <li>
    <div className="title">{title}</div>
    <div className="text">{text}</div>
  </li>
);

export default DocumentDetail;
